<template>
  <div>
    <div class="payment-title">{{ $t('fellowship.payment.payment-page-title') }}</div>
    <v-layout wrap icons justify-space-between align-end>
      <div class="icon-wrapper">
        <img src="/img/lp/lpIconMicrophone.png" alt="[Mic]" class="img-mic" />
        <div class="icon-shadow-mic"></div>
      </div>
      <div class="icon-wrapper">
        <img src="/img/lp/lpIconPhone.png" alt="[Phone]" class="img-phone" />
        <div class="icon-shadow-phone"></div>
      </div>
    </v-layout>

    <div class="bg-light"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: () => '' },
  },
};
</script>

<style scoped>
.payment-title {
  padding-top: 250px;
  font-size: 44px;
  color: #fff;
  font-weight: bold;
  line-height: 1.2em;
  text-align: center;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  white-space: pre-wrap;
}
.icons {
  position: absolute;
  left: 0;
  right: 0;
  margin-top: 40px;
  padding: 0 20px 0 80px;
}
.icon-shadow-mic,
.icon-shadow-phone {
  border-radius: 50%;
  background-color: rgba(136, 136, 136, 0.122);
  height: 15px;
  margin: 24px auto 0;
}
.icon-shadow-mic {
  width: 130%;
}
.icon-shadow-phone {
  width: 85%;
}
.bg-light {
  margin-top: 200px;
  background-image: url('/img/lp/patterns/slashLight.png');
  background-repeat: repeat;
  height: 400px;
}
@media (max-width: 767px) {
  .payment-title {
    padding-top: 140px;
    font-size: 18px;
  }
  .icons {
    margin-top: 16px;
    padding: 0 12px 0 24px;
  }
  .icon-shadow-mic,
  .icon-shadow-phone {
    height: 8px;
    margin-top: 16px;
  }
  .img-mic {
    width: 28px;
  }
  .img-phone {
    width: 78px;
  }
  .bg-light {
    margin-top: 100px;
  }
}
</style>
